// extracted by mini-css-extract-plugin
module.exports = {"iconOnHoverStyle":"u0","iconOnHoverRentalStyle":"u1"};